// extracted by css-extract-rspack-plugin
export default {"limits":"limits-n6keN0","legend":"legend-yZbrlA"};